import { analytics, FEATURES_EVENTS } from '@/common/logs';
import * as env from '@/common/environment';
import { getRandomInt } from './core.utils';

export const checkABTestingPassed = (params: {
  userId?: string | number;
  enableAbTesting: boolean;
  abValue?: string | number;
  articleId: string | number;
}) => {
  const { userId, enableAbTesting, abValue, articleId } = params;

  if (!enableAbTesting || !abValue) return true;

  const numberAbValue = Number(abValue);

  const lsKey = `abValue-${articleId}-${userId}`;
  const valueSavedInLS = localStorage.getItem(lsKey);

  const parsedAbValue: {
    configAbValue: string;
    userAbValue: string;
  } | null = valueSavedInLS ? JSON.parse(valueSavedInLS) : null;

  if (abValue && parsedAbValue && parsedAbValue.configAbValue === abValue) {
    return Number(parsedAbValue.userAbValue) <= numberAbValue;
  } else {
    const userAbValue = getRandomInt(1, 100);

    localStorage.setItem(
      lsKey,
      JSON.stringify({ configAbValue: abValue, userAbValue })
    );

    return userAbValue <= numberAbValue;
  }
};

export const checkAiABTestingPassed = (params: {
  userId?: string | number;
  enableAiAbTesting?: boolean | null;
  abValue?: string | number | null;
}) => {
  const { userId, enableAiAbTesting, abValue } = params;

  // Only logged in users allowed
  if (!userId) return false;

  const {
    bypassAbTestingUserIds,
  }: { bypassAbTestingUserIds?: string[] } = env.get('AI') || {
    bypassAbTestingUserIds: [],
  };

  const bypassAbTesting = bypassAbTestingUserIds?.includes(String(userId));

  if (bypassAbTesting) {
    // AI TODO: maybe track separately
    return true;
  }

  // If not enabled - pass automatically
  if (!enableAiAbTesting) return true;
  // If no value – not pass automatically
  if (!abValue) return false;

  const numberAbValue = Number(abValue);

  const lsKey = `AI-abValue-${userId}`;
  const valueSavedInLS = localStorage.getItem(lsKey);

  const parsedAbValue: {
    configAbValue: string;
    userAbValue: string;
  } | null = valueSavedInLS ? JSON.parse(valueSavedInLS) : null;

  if (abValue && parsedAbValue && parsedAbValue.configAbValue === abValue) {
    return Number(parsedAbValue.userAbValue) <= numberAbValue;
  } else {
    const userAbValue = getRandomInt(1, 100);

    localStorage.setItem(
      lsKey,
      JSON.stringify({ configAbValue: abValue, userAbValue })
    );

    const isEligible = userAbValue <= numberAbValue;

    if (isEligible) {
      analytics.trackAiEvent({
        name: FEATURES_EVENTS.AI_ELIGIBLE,
      });
    }

    return isEligible;
  }
};
